module.exports = __webpack_public_path__ + "static/media/480.8bdc113e.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/services/img/i8-fountain/light/480.png
// module id = 2092
// module chunks = 2